/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_External_Directories_Cta_TitleInputs */

const en_directory_external_directories_cta_title = /** @type {(inputs: Directory_External_Directories_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch on the network first`)
};

const zh_directory_external_directories_cta_title = /** @type {(inputs: Directory_External_Directories_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先在自家网络上发布`)
};

/**
* | output |
* | --- |
* | "Launch on the network first" |
*
* @param {Directory_External_Directories_Cta_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_external_directories_cta_title = /** @type {((inputs?: Directory_External_Directories_Cta_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_External_Directories_Cta_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_external_directories_cta_title(inputs)
	return zh_directory_external_directories_cta_title(inputs)
});
export { directory_external_directories_cta_title as "directory.external_directories.cta.title" }